import styled from "styled-components";
import { GlobalStyleState } from "../store/chart";
import { FontWeight, UITag } from "../types";
import { Text } from "./Text";

type TagProps = {
  className?: string;
  tag: UITag;
  styling: {
    tag: GlobalStyleState["tag"];
  };
};

export function Tag({ className, tag, styling }: TagProps) {
  return (
    <TagContainer className={className} backgroundColor={tag.background.hex}>
      <TagText font={styling.tag.font} textColor={tag.text.color}>
        {tag.text.value}
      </TagText>
    </TagContainer>
  );
}

const TagContainer = styled.span<{ backgroundColor: string }>`
  display: inline-block;
  padding: ${({ theme }) =>
    theme.isMobile
      ? `${theme.getValue(6)}px ${theme.getValue(6)}px ${theme.getValue(3)}px`
      : `${theme.getValue(10)}px ${theme.getValue(16)}px ${theme.getValue(
          7,
        )}px`};
  border-radius: ${({ theme }) =>
    theme.isMobile ? theme.getValue(4) : theme.getValue(9)}px;
  background: ${({ backgroundColor }) => backgroundColor};
`;

const TagText = styled(Text)`
  &&& {
    font-weight: ${({ font: { weight = FontWeight.Bold } = {} }) => weight};
    font-size: ${({ theme }) =>
      theme.isMobile ? theme.getFontSize(14) : theme.getFontSize(21)}px;
    line-height: 1;
    margin: 0;
    text-align: center;
    color: ${({ textColor, theme }) => textColor?.hex || theme.colors.white};
  }
`;
